<template lang="pug">
b-modal#invite-detail(title='Invite User', :hide-footer='true', ref="inviteModal")
  input(type='email', v-model='email')
  button.btn.btn-primary(@click='invite()', :disabled='!email') Invite
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      email: '',
    };
  },
  methods: {
    async invite() {
      const response = await axios.post(`events/${this.$store.state.eventId}/invites`, {
        email: this.email,
      });

      console.log(response.data);

      return this.$refs.inviteModal.hide();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/InviteModal.vue